
  <div soho-busyindicator
       [style.height]="'100%'"
       [text]="' '"
       [blockUI]="true"
       [displayDelay]="20"
       [transparentOverlay]="true">

    <ng-container *ngIf="createReportShowMain && createReportForm">
      <form [formGroup]="createReportForm" >
        <div class="row form-layout-compact">
          <div class="column">
            <div class="field">
              <label soho-label style="margin-bottom:20px">{{ 'HowWouldYouLikeToGetStarted' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="row form-layout-compact">
          <div class="one-half column">
            <div class="field field-radio">
              <input soho-radiobutton type="radio" data-automation-id="lm-create-report-copy-from-report"
                     id="reportTypeReport" value="ReportCopiedFromReport" (change)="changeReportType()" formControlName="reportType" />
              <label soho-label for="reportTypeReport" class="radio-label" data-automation-id="lm-create-report-copy-from-report-label">{{ 'CopyFromReport' | translate }}</label>

              <input soho-radiobutton type="radio" data-automation-id="lm-create-report-copy-from-list"
                     id="reportTypeList" value="ReportCopiedFromList" (change)="changeReportType()" formControlName="reportType" />
              <label soho-label for="reportTypeList" class="radio-label" data-automation-id="lm-create-report-copy-from-list-label">{{ 'CopyFromList' | translate }}</label>

              <input soho-radiobutton type="radio" data-automation-id="lm-create-report-start-from-scratch"
                     id="reportTypeOwn" value="ReportFromScratch" (change)="changeReportType()" formControlName="reportType" />
              <label soho-label for="reportTypeOwn" class="radio-label" data-automation-id="lm-create-report-start-from-scratch-label">{{ 'StartFromScratch' | translate }}</label>
            </div>
          </div>
        </div>

        <div class="row form-layout-compact ">
          <div class="column">
            <div class="field">
              <label soho-label for="reportName" [required]="true">{{ 'CreateReportNameLabel' | translate }}</label>
              <input class="input-lg" soho-input name="reportName"
                     id="reportName" data-automation-id="lm-create-report-report-name" soho-trackdirty
                     formControlName="reportName">
              <div *ngIf="((submitted || myForm.reportName.dirty) && myForm.reportName.errors)" id="name-error" class="error-message" data-automation-id="lm-create-report-report-name-alert">
                <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                  <use href="#icon-error"></use>
                </svg>
                <pre class="audible">Error</pre>
                <p class="message-text" *ngIf = "myForm.reportName.errors?.required">{{'NameIsRequiredErrorMessage' | translate}}</p>
              </div>
            </div>

            <!-- </div> -->
            <!-- <div [ngClass]="{'column': true, 'one-half': createReport.reportType !== 'ReportFromScratch'}"> -->
            <!-- </div>

            <div class="row form-layout-compact"> -->
            <!-- <div [ngClass]="{'one-half': createReport.reportType === 'ReportCopiedFromList' || createReport.reportType === 'ReportCopiedFromReport', 'column': true }"> -->
            <!-- <div class="column"> -->
            <div class="field">
              <label soho-label [required]="true" for="businessClass">{{ 'CreateReportBusinessClassLabel' | translate }}</label>
              <select #businessClass id="businessClass" name="businessClass" [attributes]="businessClassAutomationId"
                      soho-dropdown soho-trackdirty
                      formControlName="businessClass"
                      (change)="onBusClassChange()"
                      class="dropdown-lg">
                <option *ngFor="let businessClass of businessClasses" [value]="businessClass.value">{{ businessClass.label }}</option>
              </select>
            </div>
            <!-- </div> -->
            <!-- </div>
            <div class="row form-layout-compact">
              <div class="column"> -->
            <div class="field"  *ngIf="reportType.value === 'ReportCopiedFromList'">
              <label soho-label [required]="true" for="listNameLookup">{{ 'CreateReportListLabel' | translate }}</label>
              <input #listNameLookup soho-lookup
                     formControlName="listName"
                     name="listNameLookup" data-automation-id="lm-create-report-list-lookup"
                     soho-trackdirty
                     [click]="listLookupClick"
                     [clickArguments]="{'businessClass': busClass.value, 'reportType': reportType.value, 'createReportUrl': createReportUrl.value, 'component': this}"
                     class="dropdown-lg">
              <div *ngIf="((submitted || myForm.listName.dirty) && myForm.listName.errors)" id="listName-error" class="error-message" data-automation-id="lm-create-report-list-alert">
                <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                  <use href="#icon-error"></use>
                </svg>
                <pre class="audible">Error</pre>
                <p class="message-text" *ngIf = "myForm.listName.errors?.required">{{'ListIsRequiredErrorMessage' | translate}}</p>
                <p class="message-text" *ngIf = "listName.value && myForm.listName.errors?.invalidListName">{{'ListNameDoesNotExist' | translate}}</p>
              </div>
            </div>
            <!-- </div>
            <div class="column"> -->
            <div class="field"  *ngIf="reportType.value === 'ReportCopiedFromReport'">
              <label soho-label [required]="true" for="userFolderLookup">{{ 'CreateReportLabel' | translate }}</label>
              <input soho-lookup #userFolder formControlName="title"
                     name="userFolderLookup" data-automation-id="lm-create-report-userfolder-lookup"
                     soho-trackdirty
                     [click]="listLookupClick"
                     [clickArguments]="{'businessClass': busClass.value, 'reportType': reportType.value, 'createReportUrl': createReportUrl.value, 'component': this}"
                     class="dropdown-lg">
              <div *ngIf="((submitted || myForm.title.dirty) && myForm.title.errors)" id="title-error" class="error-message" data-automation-id="lm-create-report-report-alert">
                <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                  <use href="#icon-error"></use>
                </svg>
                <pre class="audible">Error</pre>
                <p class="message-text" *ngIf = "myForm.title.errors?.required">{{'ReportIsRequiredErrorMessage' | translate}}</p>
                <p class="message-text" *ngIf = "title.value && myForm.title.errors?.invalidReportName">{{'ReportTitleDoesNotExist' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container #createReportFieldsSelector *ngIf="!createReportShowMain">
      <lm-create-report-fields-dialog
              [businessClass]="busClass.value"
              [listName]="listName.value"
              [reportType]="reportType.value"
              [userFolderId]="userFolderId.value"
      ></lm-create-report-fields-dialog>
    </ng-container>
  </div>
